import React from "react";

export const Divider = ({ verticalMargin = "cw-my-1" }: { verticalMargin?: string }) => {
  return (
    <div className={`cw-border-b cw-border-solid cw-border-subtle cw-mx-4 ${verticalMargin}`} />
  );
};
